import { styled } from '@mui/material/styles';

export const WrapperDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isWrappedByLayoutContainer',
})(({ theme, isWrappedByLayoutContainer }) => ({
  marginTop: isWrappedByLayoutContainer ? 0 : theme.spacing(8),
  marginBottom: isWrappedByLayoutContainer ? 0 : theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    marginTop: isWrappedByLayoutContainer ? 0 : theme.spacing(4),
    marginBottom: isWrappedByLayoutContainer ? 0 : theme.spacing(4),
  },
}));
